import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class KeyboardEventsService {

  public updated = new EventEmitter<KeyboardEvent>()
  
  constructor() { }
}
